(() => {
  'use strict';
  const config = JSON.parse(document.getElementById('firebarns-ghost-config').textContent);
  const root = window.Shopify.routes.root;
  const marker = '_firebarns_ghost_gift';
  let queue = Promise.resolve();
  let busy = 0;
  const owned = item => item.properties && item.properties[marker] === 'v1';
  async function request(path, data) {
    const response = await fetch(root + path, {
      method: data ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      ...(data ? { body: JSON.stringify(data) } : { cache: 'no-store' }),
      signal: AbortSignal.timeout(12000)
    });
    if (!response.ok) throw new Error('Gift cart request failed: ' + response.status);
    return response.json();
  }
  const read = () => request('cart.js');
  async function removeOwned(cart) {
    const updates = {};
    cart.items.filter(owned).forEach(item => { updates[item.key] = 0; });
    return Object.keys(updates).length ? request('cart/update.js', { updates }) : cart;
  }
  async function reconcile() {
    let cart = await read();
    const active = config.enabled && cart.currency === config.currency && config.variantId && config.available;
    const amount = cart.items.reduce((sum, item) => sum + (item.product_id === config.productId || owned(item) ? 0 : item.original_line_price), 0);
    const manual = cart.items.some(item => item.product_id === config.productId && !owned(item));
    if (!active || amount < config.threshold || manual) return removeOwned(cart);
    let gifts = cart.items.filter(owned);
    if (gifts.length !== 1 || gifts[0].variant_id !== config.variantId || gifts[0].quantity !== 1) {
      await removeOwned(cart);
      await request('cart/add.js', { items: [{ id: config.variantId, quantity: 1, properties: { [marker]: 'v1' } }] });
      cart = await read();
      gifts = cart.items.filter(owned);
    }
    if (gifts.length !== 1 || gifts[0].final_line_price !== 0) {
      await removeOwned(cart);
      throw new Error('GHOST75 not applied: automatically added gift removed');
    }
    return cart;
  }
  function showError() {
    let box = document.getElementById('firebarns-gift-error');
    if (!box) {
      box = document.createElement('div');
      box.id = 'firebarns-gift-error';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'position:fixed;bottom:20px;left:20px;right:20px;z-index:99999;background:#fff;color:#222;border:2px solid #be2026;padding:16px;';
      box.addEventListener('click', () => box.remove());
      document.body.appendChild(box);
    }
    box.textContent = config.error;
  }
  const api = window.FirebarnsGhost = {
    sync() {
      const result = queue.then(reconcile);
      queue = result.catch(() => {});
      return result;
    },
    async safeSync() {
      try { await api.sync(); } catch (error) { console.warn(error); showError(); }
    },
    begin() { busy += 1; },
    end() { busy = Math.max(0, busy - 1); },
    get busy() { return busy > 0; }
  };
  let checkoutBusy = false;
  let replay = false;
  async function guard(event, resume) {
    if (replay) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutBusy || api.busy || document.querySelector('.cart-form--refreshing, .merge-item-refreshing')) return;
    checkoutBusy = true;
    try {
      await api.sync();
      replay = true;
      resume();
    } catch (error) {
      showError();
      document.dispatchEvent(new CustomEvent('theme:cartchanged'));
    } finally {
      replay = false;
      checkoutBusy = false;
    }
  }
  document.addEventListener('click', event => {
    const target = event.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (target) guard(event, () => target.click());
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter && event.submitter.name === 'checkout') {
      guard(event, () => event.target.requestSubmit(event.submitter));
    }
  }, true);
  document.addEventListener('DOMContentLoaded', async () => {
    await api.safeSync();
    document.dispatchEvent(new CustomEvent('theme:cartchanged'));
  });
})();
